import React from "react";
import { saveAs } from "file-saver";
import { requestJson, RequestMethod } from "helpers/httpHelper";

export default function OfferCard({ offer, selectOffer }) {
   const getOfferPdf = async () => {
      const response = await requestJson(`/oferta/document/${offer.cod}`, RequestMethod.GET);
      if (response.isSuccess) return response.response;
   };

   const downloadPDF = async () => {
      const pdfOfferLink = await getOfferPdf();
      const lastDotIndex = pdfOfferLink.lastIndexOf(".");
      const extension = pdfOfferLink.substring(lastDotIndex + 1);
      saveAs(pdfOfferLink, `oferta-${offer.cod}.${extension}`);
   };

   return (
      <div className="row row-oferta mx-auto">
         <div className="col-md-12 text-center">
            <h3 className="font-size-36">{offer.info}</h3>
            <div className="row col-md-12 mx-auto">
               <div className="col-md-2">
                  <p className="text-center after-p border-blue font-size-24 mb-3 font-kanit position-relative mt-100">Preț gaze naturale</p>
                  <p className="text-center font-kanit font-size-36 mb-3">{offer.gaz}</p>
               </div>
               <div className="col-md-2">
                  <p className="text-center after-p border-grey font-size-24 mb-3 font-kanit position-relative mt-100">Cost transport</p>
                  <p className="text-center font-kanit font-size-36 mb-3">{offer.transport}</p>
               </div>
               <div className="col-md-2">
                  <p className="text-center after-p border-orange font-size-24 mb-3 font-kanit position-relative mt-100">Tarif distribuție</p>
                  <p className="text-center font-kanit font-size-36 mb-3">{offer.distributie}</p>
               </div>
               <div className="col-md-2">
                  <p className="text-center after-p border-green font-size-24 mb-3 font-kanit position-relative mt-100">Preț final</p>
                  <p className="text-center font-kanit font-size-36 mb-3">{offer.total}</p>
               </div>
               <div className="col-md-2">
                  <p className="text-center after-p border-green font-size-24 mb-3 font-kanit position-relative mt-100">Preț final cu TVA</p>
                  <p className="text-center font-kanit font-size-36 mb-3">{offer.totalcutva}</p>
               </div>
               <div className="phone-screen">
                  <p className="color-gray2 text-center mt-4">*Tarif exprimat în lei/kWh</p>
                  <div className="text-center mt-20 offer-buttons">
                     <a onClick={() => downloadPDF()} className="order-last mt-3 second-link mr-3 cursor-pointer">
                        Descarcă oferta
                     </a>
                     <button
                        onClick={() => selectOffer("cod", offer.cod)}
                        type="submit"
                        className="main-link bg-green d-inline-block w-auto mt-2 agree"
                     >
                        <span>Alege oferta</span>
                        <i className="fa fa-angle-right ml-5"></i>
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
